import { useReduxState } from 'hooks';
import { Avatar, Link } from 'components/common';
import { Box, BoxRow } from 'components/common/box';

import type { PageState } from 'types';

interface Props {
  paths: PageState['course']['paths'];
}

const CoursePaths = ({ paths }: Props) => {
  const { messages } = useReduxState();

  return (
    <div className="paths">
      <Box padding={0} title={messages.commonPaths}>
        {paths.map((path) => (
          <BoxRow key={path.id}>
            <Link
              href={`/paths/${path.id}`}
              linkColor="inherit"
              style={{ display: 'flex', gap: '10px' }}
            >
              <div className="path-icon">
                <Avatar
                  fontSize="1.4rem"
                  icon="tasks"
                  padding="6px 0"
                  size="30px"
                />
              </div>
              <div className="path-title">{path.title}</div>
            </Link>
          </BoxRow>
        ))}
      </Box>

      <style jsx>{`
        .path-title {
          font-size: 1.5rem;
          font-weight: 600;
          padding-top: 5px;
        }
      `}</style>
    </div>
  );
};

export default CoursePaths;
